export class ClientSearchSelectionCriteria {
  clientName: string;
  programName: string;
  programType: string;
  clientStatus: string;
}
